import { padStart } from 'lodash';

const pad = n => padStart(n, 2, '0');
const timestampToStr = (ts) => {
  const d = new Date(ts);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    + ` ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export default {
  /**
   * 取得空图表时的假数据
   * @param {timestamp} startTime 
   * @param {timestamp} endTime
   * @returns {object} 
   */
  getEmptyData (startTime, endTime) {
    return {
      [timestampToStr(startTime)]: null,
      [timestampToStr(endTime)]: null
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/bandwidthTraffic/chart.helper.js